// Empty page, everything is handled in +onRenderHtml and +onRenderClient
export default function render() {
  return null
}
